module.exports = __webpack_public_path__ + "static/vegan-3a866ec3e74c9b318afdaa40bc04491a.png";